/**
 * This function allows uploaded files to be mapped to a specific format
 * @returns {function} onUploadCompleted - This fn returns mapped files of uploadedFiles
 * @example{
 *   const fileUpload = useFileUpload(); // Return onUploadCompleted fn
 *
 *   const uploadedFiles = [
 *   {
 *       data: {
 *         relativePath: 'path4',
 *      },
 *      file: {
 *        width: 1080,
 *        height: 1080,
 *      },
 *    }
 *   ];
 *
 *  const result = fileUpload(uploadedFiles);
 *
 *  result = [
 *    {
 *      path: 'path4',
 *      width: 1080,
 *      height: 1080,
 *    }
 *  ]
 * }
 */
const useFileUpload = () => {
  const onUploadCompleted = uploadedFiles => uploadedFiles.map(file => ({
    path: file.data.relativePath,
    width: file.file.width,
    height: file.file.height,
  }));

  return {
    onUploadCompleted,
  };
};

export default useFileUpload;
